import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlgoSymbolPlChartComponent } from './algo-symbol-pl-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { PrecisionModule } from '@app/_shared/pipes';



@NgModule({
  declarations: [
    AlgoSymbolPlChartComponent
  ],
  imports: [
    CommonModule,
    NgxEchartsModule,
    PrecisionModule
  ],
  exports: [
    AlgoSymbolPlChartComponent
  ]
})
export class AlgoSymbolPlChartModule { }
